import React, { useState } from 'react';
import { TimePicker } from 'antd';

const PushTimePicker = (props) => {
    const [val, setVal] = useState(null);

    const onPickerSelected = (moment, value) => {
        setVal(moment, value)

        if ("onSelect" in props && props.onSelect) {
            console.log("onSelect " + val)
            props.onSelect(moment, value);
        }

    }
    const onBlur = () => {
        console.log("onBlur")

        if ("onChange" in props && props.onChange) {
            console.log("onChange " + val)
            props.onChange(val);
        }
        // props?.onChange(val);
    };
    return <TimePicker {...props} onSelect={onPickerSelected} onOpenChange={isOpen => {
        if (!isOpen)
            onBlur()
    }} />
}

export default PushTimePicker